import React from 'react';
import './Skeleton.css';

/**
 * Generic skeleton loader. Renders `count` shimmer bars.
 * @param {number} width  — CSS value, e.g. '100%' or '200px'
 * @param {number} height — CSS value, e.g. '16px'
 * @param {number} count  — how many bars to render
 * @param {string} className — extra class
 */
export default function Skeleton({ width = '100%', height = '16px', count = 1, className = '' }) {
  return (
    <div className={`skeleton-container ${className}`} aria-busy="true" aria-label="Loading…">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="skeleton-bar" style={{ width, height }} />
      ))}
    </div>
  );
}
